import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from '@saucelabs/sl-component-router';

import { BANNER_EVENTS, ORG_ROLES, trackEvent } from '../../../tracking';
import Banner from '../Banner';

const PaymentDeclined = (props) => {
  const { baseHref, isOrganizationAdmin, isTeamAdmin } = props;
  let role;
  if (isOrganizationAdmin) {
    role = ORG_ROLES.ORG_ADMIN;
  } else if (isTeamAdmin) {
    role = ORG_ROLES.TEAM_ADMIN;
  } else {
    role = ORG_ROLES.NON_ADMIN;
  }

  useEffect(() => {
    trackEvent(BANNER_EVENTS.BANNER_PAYMENT_FAILED_DISPLAYED, {
      role,
    });
  }, []);

  let Content;
  if (isOrganizationAdmin) {
    // messaging for org admin who has billing access
    Content = (
      <span>
        To continue using Sauce Labs without interruption, please
        {' '}
        <NavLink
          baseHref={baseHref}
          onClick={() => trackEvent(BANNER_EVENTS.BANNER_PAYMENT_FAILED_CLICK, {
            role,
          })}
          to="/billing/billing-information"
        >
          update your payment information
        </NavLink>
        .
      </span>
    );
  } else {
    // messaging for non-org-admin
    // link to team management page if team admin
    const contactOrgAdminText = 'contact your organization admin';
    Content = (
      <span>
        To continue using Sauce Labs without interruption,
        please
        {' '}
        {isTeamAdmin ? (
          <NavLink
            baseHref={baseHref}
            onClick={() => trackEvent(BANNER_EVENTS.BANNER_PAYMENT_FAILED_CLICK, {
              role,
            })}
            to="/team-management/users"
          >
            {contactOrgAdminText}
          </NavLink>
        ) : (contactOrgAdminText)}
        { ' or '}
        <a
          href="mailto:support@saucelabs.com"
          onClick={() => trackEvent(BANNER_EVENTS.BANNER_PAYMENT_FAILED_MAILTO_SUPPORT, { role })}
        >
          support@saucelabs.com
        </a>
        { '.'}
      </span >
    );
  }

  return (
    <Banner
      color="orange"
    >
      <div className="flex flex-row justify-center items-center">
        <p className="my-0 mx-1 text-base">
          <strong>Payment Declined:</strong>
          {' '}
          {Content}
        </p>
      </div>
    </Banner>
  );
};

PaymentDeclined.propTypes = {
  baseHref: PropTypes.string,
  isOrganizationAdmin: PropTypes.bool.isRequired,
  isTeamAdmin: PropTypes.bool.isRequired,
};

PaymentDeclined.defaultProps = {
  baseHref: window.location.origin,
};

export default PaymentDeclined;
export { PaymentDeclined };
